module.exports = __webpack_public_path__ + "components/Game/Steps/Intruder/IntruderQuestionImage-3.391c2328a4857f63782d6137cba95657.jpg";